// extracted by mini-css-extract-plugin
export default {"bounce":"w_cQ","loading":"w_cR","logo-mark-bounce-right":"w_cS","logo-mark-bounce-left":"w_cT"};